import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    padding: 14px 20px;
    max-width: 64.875rem;

    gap: 12px;
    display: flex;
    align-items: center;

    background-color: ${theme.colors.red.fundo};
    border-radius: 1rem;
    box-sizing: border-box;

    img {
        width: 2rem;
        height: 2rem;
        flex-shrink: 0;
    }

    @media (max-width: 767px) {
        align-items: flex-start;
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;

    @media (max-width: 767px) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1;
`;

export const ResolveButton = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 0.75rem 1.5rem;
    border-radius: 10rem;
    background-color: ${theme.colors.red.Vermelho_erro};
    color: ${theme.colors.white.Branco};
    font-family: "Lato", sans-serif;
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.05rem;
    text-transform: uppercase;
    text-decoration: none;
    white-space: nowrap;

    @media (max-width: 767px) {
        align-self: flex-start;
    }
`;
